import React, { useState } from 'react';
import EditConfigForm from './EditConfigForm';
import { Auth, API } from 'aws-amplify';
import './ConfigurationTab.css';

function ConfigurationTab({ configData, onConfigEdited, userRole}) {
    console.log("Configuration Data:", configData);
    const [editingConfig, setEditingConfig] = useState(null);
    const [isEditing, setIsEditing] = useState(false);

    const openEditForm = (config) => {
        setEditingConfig({
            ...config,
            title: configData.title,
        });
        setIsEditing(true);
    };

    const closeEditForm = () => {
        setEditingConfig(null);
        setIsEditing(false);
    };
    const saveChanges = async (updatedConfig) => {
        try {
            const currentUser = await Auth.currentAuthenticatedUser();
            const userOrganization = currentUser.attributes['email'].split('@')[1].split('.')[0];
            const apiName = 'EditConfig';
            const path = `/edit/${updatedConfig.title}`;
    
            const transformedColumns = updatedConfig.columns.map((column) => ({
                nameInFile1: column.nameInFile1,
                nameInFile2: column.nameInFile2,
                standardName: column.standardName,
                dataType: column.dataType,
            }));
    
            const bodyData = {
                columns: transformedColumns,
                filename1: updatedConfig.filename1,
                filename2: updatedConfig.filename2,
                matchingThreshold: String(updatedConfig.matchingThreshold),
                uniqueIdentifierColumn: updatedConfig.uniqueIdentifierColumn,
                title: updatedConfig.title,
                type: updatedConfig.type,
                organization: userOrganization,
                user: currentUser.attributes['email'],
                automateRuns: updatedConfig.automateRuns || "false" // Ensure automateRuns is included as a string
            };
    
            const response = await API.put(apiName, path, { body: bodyData });
            alert('Changes saved successfully!');
        } catch (error) {
            alert('Error saving changes, please try again.');
        }
    };
    

    const deleteConfiguration = async () => {
        if (userRole !== 'Admin') {
            alert('Only Admins can delete a configuration.');
            return;
        }
    
        const isConfirmed = window.confirm(
            `Are you sure you would like to delete the configuration "${configData.title}"?`
        );
        if (!isConfirmed) return;
    
        try {
            const currentUser = await Auth.currentAuthenticatedUser();
            const userEmail = currentUser.attributes['email'];
    
            // Extract the organization from the email domain
            const organization = userEmail.split('@')[1].split('.')[0];
    
            const apiName = 'DeleteRecon';
            const path = '/deleteRecon';
            const bodyData = {
                title: configData.title,
                user: userEmail,
                organization: organization, // Add the extracted organization
            };
    
            await API.post(apiName, path, { body: bodyData });
            console.log(bodyData);
    
            alert('Configuration deleted successfully!');
            // Optionally refresh the state or notify the parent component
        } catch (error) {
            alert('Error deleting configuration, please try again.');
        }
    };
    
  

   
    return (
        <div className="config-tab-container">
            {configData && (
                <div className="config-data">
                    <h2 className="config-data-title">Configuration Data</h2>
                    {['user', 'filename1', 'filename2', 'title', 'type'].map((key) => {
    if (configData[key]) {
        return (
            <div key={key} className="config-tab-data-item">
                <h3 className="data-item-title">
                    {key.charAt(0).toUpperCase() + key.slice(1)}
                </h3>
                <p className="data-item-detail">{configData[key]}</p>
            </div>
        );
    }
    return null;
})}

{/* Subtle SideA and SideB display (only if automateRuns is true) */}
{configData.sides && configData.automateRuns === "true" && (
    <div className="config-tab-data-item subtle-info">
        <p><strong>Side A:</strong> {configData.sides.SideA.name} ({configData.sides.SideA.SideStatus})</p>
        <p><strong>Side B:</strong> {configData.sides.SideB.name} ({configData.sides.SideB.SideStatus})</p>
    </div>
)}


                    
                    {/* Edit Configuration Button */}
                    <button
                        onClick={() => openEditForm(configData)}
                        className="edit-config-button"
                    >
                        Edit Configuration
                    </button>
    
                    {/* Delete Configuration Button (Only for Admins) */}
                    {userRole === 'Admin' && (
                        <button
                            onClick={deleteConfiguration}
                            className="delete-config-button"
                        >
                            Delete Configuration
                        </button>
                    )}
                </div>
            )}
    
            {editingConfig && isEditing && (
                <EditConfigForm
                    className="edit-config-form"
                    editingConfig={editingConfig}
                    setEditingConfig={setEditingConfig}
                    saveChanges={saveChanges}
                    closeEditForm={closeEditForm}
                />
            )}
        </div>
    );
    
}

export default ConfigurationTab;
